export default function adlightning() {
  return `<script src="https://tagan.adlightning.com/mansueto/op.js" async ></script>`;
}
